import { useEffect } from 'react';
import { Alert, Dialog } from '@elementary/common-ui/components';
import useNango from 'shared/hooks/useNango';
import { themeTokens } from '@elementary/common-ui/style/tokens';

type Props = {
  open: boolean;
  onClose: () => void;
  environmentId: string;
};

const LinearReauthDialog = ({ open, onClose, environmentId }: Props) => {
  const { nangoAuth, success: nangoSuccess, error: nangoError } = useNango();

  useEffect(() => {
    if (nangoSuccess) {
      onClose();
    }
  }, [nangoSuccess, onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Re-authenticate Linear"
      confirmText={nangoError ? 'Try again' : 'Reconnect with Linear'}
      cancelText="Cancel"
      onConfirmButtonClick={() =>
        nangoAuth('linear', undefined, undefined, environmentId)
      }
      message={
        nangoError ? (
          <Alert
            severity="error"
            style={{ fontWeight: themeTokens.fontWeight.bold }}
          >
            Linear re-authentication failed. Please try again or contact
            support.
          </Alert>
        ) : (
          'Re-authenticating will refresh your Linear permissions. You will be redirected to Linear to grant access.'
        )
      }
    />
  );
};

export default LinearReauthDialog;
